import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Layout, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import api from './axios_instance';
import { session, SessionChanged, SessionExpired } from './session';

export const ProtectedRoute = ({ children }) => {
  const { t } = useTranslation('translation');
  const [status, setStatus] = useState('checking');
  const [attempt, setAttempt] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    setStatus('checking');
    let id;
    const check = async () => {
      try {
        id = session.read()?.id;
        await session.accessToken({ expectedId: id });
        // A stalled backend dependency must not leave the login screen loading indefinitely.
        if (process.env.REACT_APP_API_URL) await api.get('me', { sessionId: id, timeout: 15000 });
        if (!cancelled) setStatus('ready');
      } catch (error) {
        if (cancelled) return;
        if (error instanceof SessionExpired) navigate('/login', { replace: true });
        else if (error instanceof SessionChanged) window.location.reload();
        // A 401 after renewal is an authentication rejection, not a connection outage.
        else if (error.response?.status === 401) setStatus('rejected');
        // Preserve the existing organization-creation flow, without new permissions.
        else if (error.response?.status === 400) setStatus('ready');
        else setStatus('retry');
      }
    };
    const onStorage = (event) => {
      if (event.key === session.key && session.read()?.id !== id) window.location.reload();
    };
    window.addEventListener('storage', onStorage);
    check();
    return () => { cancelled = true; window.removeEventListener('storage', onStorage); };
  }, [navigate, attempt]);
  if (status === 'ready') return children;
  return <Layout className='view-loading-overlay'><div className='view-loading-overlay-content'>
    {status === 'checking' ? <Spin /> : status === 'rejected' ? <>
      <p>{t('auth.sessionRejected')}</p>
      <Button onClick={() => navigate('/login', { replace: true })}>{t('auth.login')}</Button>
    </> : <>
      <p>{t('auth.sessionUnavailable')}</p>
      <Button onClick={() => setAttempt((value) => value + 1)}>{t('auth.retry')}</Button>
    </>}
  </div></Layout>;
};
